import $ from 'jquery';
import layout from '~/js/services/layout';
import scroller from '~/js/services/scroller';


const accordion = function (options) {
    let o, m, internal, elements, fn, handlers;


    o = $.extend({
        $e: null,
        selector: '',
        fallbackId: null,
        multiselect: false,
        triggerLayout: false // panel open/close triggers layout; panel scroll triggers scoller
    }, options);


    m = accordion.markup;


    internal = {
        $e: o.$e || $(o.selector),
        fallbackId: o.fallbackId,
        multiselect: o.multiselect,
        setup: false,
        triggerLayout: o.triggerLayout
    };


    elements = {
        tabs: internal.$e.find(`.${m.TAB}`),
        panels: internal.$e.find(`.${m.PANEL}`)
    };


    fn = {
        init () {
            fn.setup();
        },

        setup () {
            elements.tabs.each(function (tabIndex) {
                const $tab = $(this);
                const $panel = $tab.parent(`.${m.LEVEL}`).find(`.${m.PANEL}:first`);
                const tabId = $tab[0].id || `accordion-${internal.fallbackId}-tab-${tabIndex}`;
                const panelId = $panel[0].id || `accordion-${internal.fallbackId}-panel-${tabIndex}`;

                $tab.attr({
                    'role': 'tab',
                    'id': tabId,
                    'aria-controls': panelId,
                    'aria-expanded': false,
                    'aria-selected': false
                });

                $panel
                    .attr({
                        'role': 'tabpanel',
                        'id': panelId,
                        'aria-labelledby': tabId,
                        'aria-hidden': true
                    })
                    .css('display', 'none');

                $tab.on('click.accordion', handlers.tabClicked);

                internal.$e.addClass(m.SETUP);
                internal.setup = true;
            });

            if (internal.triggerLayout) {
                elements.panels.on('scroll', scroller.trigger);
            }
        },

        openPanel ($panel) {
            const $panelLevel = $panel.parent(`.${m.LEVEL}`);

            if (!internal.multiselect) {
                var $openedPanels = $panelLevel.siblings(`.${m.ACTIVE}`).children(`.${m.PANEL}`);
                if ($openedPanels.length > 0) {
                    this.closePanel($openedPanels.not($panel));
                }
            }

            if (internal.triggerLayout) {
                // trigger layout as soon as panel becomes visible
                setTimeout(layout.trigger);
            }

            $panel.attr('aria-hidden', false).slideDown(function () {
                if (internal.triggerLayout) {
                    layout.trigger();
                }
            });

            $panelLevel.addClass(m.ACTIVE);

            $(`#${$panel.attr('aria-labelledby')}`).attr({
                'aria-expanded': true,
                'aria-selected': true
            });
        },

        closePanel ($panel) {
            $panel.attr('aria-hidden', true);

            if ($panel.is(':visible')) {
                $panel.slideUp(function () {
                    if (internal.triggerLayout) {
                        layout.trigger();
                    }
                });
            }

            $panel.parent(`.${m.LEVEL}`).removeClass(m.ACTIVE);

            $(`#${$panel.attr('aria-labelledby')}`).attr({
                'aria-expanded': false,
                'aria-selected': false
            });
        },

        isValidBreakpoint () {
            return internal.breakpoints.includes(layout.getInfo().breakpoint.name);
        },

        destroy () {
            elements.tabs.each(function (tabIndex) {
                const $tab = $(this);
                const $panel = $tab.parent(`.${m.LEVEL}`).find(`.${m.PANEL}`);

                $tab.removeAttr('role aria-controls aria-expanded aria-selected')
                    .off('.accordion');

                $panel.stop(true)
                    .slideUp(0)
                    .css('display', '')
                    .removeAttr('role aria-labelledby aria-hidden');
            });

            internal.$e.removeClass(m.SETUP);
            internal.setup = false;
        }
    };


    handlers = {
        tabClicked () {
            const $parent = $(this).parent(`.${m.LEVEL}`);
            const $panel = $parent.find(`.${m.PANEL}:first`);

            if ($parent.hasClass(m.ACTIVE)) {
                fn.closePanel($panel);
            } else {
                fn.openPanel($panel);
            }
        }
    };


    fn.init();
};


accordion.markup = {
    // dom selector
    CONTAINER: 'accordion',
    LEVEL: 'accordion__level',
    TAB: 'accordion__tab',
    PANEL: 'accordion__content',

    // states
    SETUP: 'state-setup',
    ACTIVE: 'state-active'
};


export default accordion;



// WEBPACK FOOTER //
// ./assets/js/components/accordion.js